import React from "react";
import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import ComponentCard from "../Common/ComponentCard";
import DeliveryControlledEntityCreateModal from "./DeliveryControlledEntityCreateModal";


class DeliveryControlledEntityInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            entities: null
        };
    }

    async componentDidMount() {
        await this.retrieveEntities();
    }

    async retrieveEntities(){
        const url = 'delivery_controlled_entity/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                delivery: this.props.delivery.id
            }
        );
        this.setState(
            {
                entities: response.data.results
            }
        );
    }

    render() {
        if (!this.state.entities){
            return (
                <CircularProgress/>
            )
        }
        return(
            <Stack>
                <DeliveryControlledEntityCreateModal
                    delivery={this.props.delivery}
                    callBack={this.retrieveEntities.bind(this)}
                />
                {
                    this.state.entities.map(
                        (each) => (
                            <ComponentCard
                                key={'ComponentCard'+each.entity+each.entity_id}
                                entity={each.entity}
                                entity_id={each.entity_id}
                            />
                        )
                    )
                }
            </Stack>
        )
    }
}

export default DeliveryControlledEntityInner